import { useEffect } from 'react';

const APP_NAME = 'Soccertycs';

const usePageTitle = (title) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title ? `${title} | ${APP_NAME}` : APP_NAME;
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};

export default usePageTitle;
